import React from "react";
import LBox, { LBoxProps } from "@components/LBox";
import LIcon, { IconName } from "@components/LIcon";
import LText from "@components/LText";
import { TextProps } from "@shopify/restyle";
import { Theme } from "@theme";
// import { formatDuration } from "@utils/time";
import dayjs from "dayjs";
import { TextProps as RNTextProps } from "react-native";
import { Access, EventStartLocal } from "@libs/wire";

type AccessConcertEventInfoProps = {
  access: Access;
  textProps?: TextProps<Theme>;
};

export const AccessCardInfo = ({
  access,
  textProps,
}: AccessConcertEventInfoProps) => {
  switch (access.type) {
    case "event":
      return (
        <LBox flexDirection="column" gap="s2">
          <AccessDate
            startsAtLocal={access.startsAtLocal}
            textProps={textProps}
          />
          <AccessCardLabel
            icon="location_pin"
            iconColor="greyText"
            text={
              access.venue && access.city && access.country
                ? `${access.venue} (${access.city}, ${access.country})`
                : access.venue && access.city
                  ? `${access.venue}, ${access.city}`
                  : access.city && access.country
                    ? `${access.city} • ${access.country}`
                    : access.city || access.venue || ""
            }
            textProps={{
              style: { flexShrink: 1 },
              numberOfLines: undefined,
              ...textProps,
            }}
          />
        </LBox>
      );
    case "music":
      return (
        <LBox flexDirection="column" gap="s2">
          <AccessCardLabel
            text={access.songs.at(0)?.title ?? ""}
            textProps={{
              style: { flexShrink: 1 },
              numberOfLines: undefined,
              ...textProps,
            }}
            containerProps={{
              flex: 1,
              alignItems: "flex-start",
              mr: "s2",
            }}
          />
        </LBox>
      );

    // case "service_talk_video":
    //   return (
    //     <>
    //       <ExperienceDate date={dateTime} textProps={textProps} />
    //       <ExperienceCardLabel
    //         icon="alarm_clock_white"
    //         text={formatDuration(eventInfo.duration ?? 0)}
    //         textProps={textProps}
    //       />
    //     </>
    //   );

    // case "merch":
    default:
  }
};

type LabelProps = {
  icon?: IconName;
  iconColor?: string;
  text: string;
  textProps?: TextProps<Theme> & RNTextProps;
  containerProps?: LBoxProps;
};

export const AccessCardLabel = ({
  icon,
  iconColor,
  text,
  textProps,
  containerProps,
}: LabelProps) => {
  return (
    <LBox flexDirection="row" gap="s1" alignItems="center" {...containerProps}>
      {icon === "location_pin" ? (
        <LIcon
          colors={{ color: iconColor ?? "white" }}
          name="location_pin"
          size={12}
        />
      ) : icon ? (
        icon === "calendar" ? (
          <LIcon
            colors={{ color: iconColor ?? "white" }}
            name="calendar"
            size={12}
          />
        ) : (
          <LIcon name={icon} size={12} stroke={iconColor} />
        )
      ) : null}
      <LText numberOfLines={1} variant="experienceSubtitleText" {...textProps}>
        {text}
      </LText>
    </LBox>
  );
};

type AccessDateProps = {
  startsAtLocal: EventStartLocal;
  textProps?: TextProps<Theme>;
};

// Venue-local `{ date, time }` resolved server-side (2026-07-23 convention):
// render literally. Parse the plain date/time locally so nothing shifts.
const AccessDate = ({ startsAtLocal, textProps }: AccessDateProps) => {
  const dateLabel = dayjs(startsAtLocal.date).format("MMM DD");
  const text = startsAtLocal.time
    ? `${dateLabel} - ${dayjs(`2000-01-01T${startsAtLocal.time}`).format("h:mm a")}`
    : dateLabel;
  return (
    <AccessCardLabel
      icon="calendar"
      iconColor="greyText"
      text={text}
      textProps={textProps}
    />
  );
};
